import React, { useEffect, useState } from 'react';
const START_SECONDS = 2 * 60 * 60;
function format(total: number) {
  const h = Math.floor(total / 3600);
  const m = Math.floor(total % 3600 / 60);
  const s = total % 60;
  return [h, m, s].map(n => String(n).padStart(2, '0')).join(':');
}
export function CountdownBar() {
  const [left, setLeft] = useState(START_SECONDS);
  useEffect(() => {
    const endsAt = Date.now() + START_SECONDS * 1000;
    const id = window.setInterval(() => {
      const next = Math.max(0, Math.round((endsAt - Date.now()) / 1000));
      setLeft(next);
      if (next === 0) window.clearInterval(id);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  return <div className="sticky top-0 z-50 bg-gradient-to-r from-[#F4B9CF] via-[#EBC6E4] to-[#D6C6F4] shadow-[0_2px_10px_rgba(140,111,201,0.15)]" data-id="element-60" data-mp="5ygxrexr1b3m">
      <div className="mx-auto flex min-h-[3.5rem] max-w-6xl flex-wrap items-center justify-center gap-x-2 gap-y-1 px-4 py-2 text-[13px] font-semibold text-ink sm:text-sm" data-id="element-61" data-mp="2mmkyk3a6mckj">
        <span data-id="element-62" data-mp="3szioltq9s47q">🎨Bevezető ajánlat — csak ma — lejár:</span>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-white/50 px-3.5 py-1 font-display text-base font-bold tabular-nums" data-id="element-63" data-mp="3t257gpim2659">
          <span aria-hidden="true" data-id="element-64" data-mp="5vunkls33uoo">⏰</span>
          {format(left)}
        </span>
      </div>
    </div>;
}